import React, { useState } from "react";
import GridContainer from "../../components/GridContainer";
import logo from "../../assets/image/atlantis.png";
import { makeStyles } from "@material-ui/styles";
import Link from "@material-ui/core/Link";
import Heart from "@material-ui/icons/FavoriteBorder";
import multiLang from "../../lang/lang.json";
import { connect } from "react-redux";
import { setLang, setUser, logOut, myInvoice } from "../../redux/actions";
import Menu from "./Header";
import HeaderLinks from "./HeaderLinks";
import Login from "./Login";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Badge from "../badge";
import AutoComplete from "../AdvancedSearch/AutoComplete";
import SelectCountry from "./SelectCountry";
import Language from "@material-ui/icons/Language";
import { Cart } from "../icons";
import Grid from "@material-ui/core/Grid";
import Person from "@material-ui/icons/PersonOutline";

const useStyles = makeStyles({
  logo: {
    lineHeight: "105px",
    "& img": {
      width: "130px",
      verticalAlign: "middle"
    }
  },
  inline: {
    display: "inline-flex",
    "& p": {
      alignSelf: "center"
    }
  },
  shop: {
    overflow: "hidden",
    lineHeight: "100px",
    display: "inline-block",
    // width: "20%",
    // height: "100%",
    // background: "#f5a623",
    padding: "0 !important",
    textAlign: "center",
    cursor: "pointer"
  },
  changeLanguage: {
    "@global": {
      ".MuiSelect-select": {
        width: "80%"
      }
    },
    "&::before": {
      content: "none"
    },
    "&::after": {
      content: "none"
    }
  },
  Singout: {
    padding: "0 5px",
    fontSize: "11px",
    display: "inline-block !important",
    height: "35px",
    marginTop: "0px",
    background: "none",
    boxShadow: "none",
    color: "black",
    "&:hover": {
      backgroundColor: "#ffa500",
      color: "white"
    }
  },
  nopadding: {
    padding: "0"
  },
  besidesearch: {
    direction: "rtl"
  },
  besidesearchRtl: {
    direction: "ltr !important"
  }
});

const Header = ({ ...props }) => {
  const [loading, setLoading] = useState(false);
  const [display, setDisplay] = useState(false);
  const [isopen, setIsopen] = useState(false);

  React.useEffect(() => {
    document.body.addEventListener("click", () => setDisplay(false));
  }, []);
  const {
    language: { lang, dir },
    setLang,
    setUser,
    user,
    categories,
    logOut,
    myInvoice,
    productnumber
  } = props;
  const classes = useStyles();

  return (
    <div className={dir === "rtl" ? "rtl" : "ltr"}>
      <Hidden smDown implementation="css">
        <GridContainer style={{ height: "100px" }}>
          <Grid
            xs={12}
            sm={6}
            md={8}
            lg={8}
            style={{ display: "inline-flex" }}
            item
          >
            <Link className={classes.logo} href={"/home"}>
              <img src={logo} alt="logo" />
            </Link>
            <AutoComplete lang={lang} dir={dir} />
          </Grid>
          <Grid xs={12} sm={6} md={4} lg={4} item>
            <div style={{ display: "inline-flex", width: "100%" }}>
              <div
                style={{
                  display: "inline-block",
                  width: "100%",
                  overflow: "hidden",
                  padding: "0"
                  // height: "100%",
                  // marginTop: "45px"
                }}
              >
                <div
                  style={{
                    display: "flex"
                  }}
                  className={
                    dir === "ltr"
                      ? classes.besidesearch
                      : classes.besidesearchRtl
                  }
                >
                  <div
                    className={classes.shop}
                    onClick={() => window.location.replace("/cart")}
                  >
                    <Badge
                      count={productnumber}
                      // count={0}
                    >
                      {Cart}
                    </Badge>
                  </div>
                  <div
                    onClick={() => setDisplay(true)}
                    style={{ alignSelf: "center" }}
                  >
                    <span
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        paddingTop: "10px"
                      }}
                    >
                      <Language />
                    </span>
                    <div
                      style={{
                        display: display ? "block" : "none",
                        position: "absolute",
                        background: "white",
                        zIndex: "99999",
                        padding: "5px",
                        borderRadius: "3px",
                        marginTop: "10px",
                        width: "200px",
                        boxShadow: "0px 5px 8px black",
                        margin: "0 -90px"
                      }}
                    >
                      <SelectCountry
                        setLang={e =>
                          setLang({
                            lang: e,
                            dir: e === "fa" ? "rtl" : "ltr"
                          })
                        }
                        multiLang={multiLang}
                        lang={lang}
                      />
                    </div>
                  </div>
                  <div style={{ alignSelf: "center", margin: "15px 15px 0" }}>
                    <Link
                      color="inherit"
                      href={"/"}
                      style={{
                        display: "inline-flex",
                        alignSelf: "center"
                        // borderRight: "1px solid",
                        // borderLeft: "1px solid",
                        // margin: "0 5px",
                        // padding: "0 5px"
                      }}
                    >
                      <Heart />
                      {multiLang["012"][lang]}
                    </Link>
                  </div>
                  {!user.isLogin ? (
                    <div style={{ alignSelf: "center", margin: "10px 0 0" }}>
                      <Login
                        setUser={setUser}
                        lang={lang}
                        dir={dir}
                        multiLang={multiLang}
                        myInvoice={myInvoice}
                        header={true}
                        isopen={isopen}
                        close={() => setIsopen(false)}
                        setIsopen={e => setIsopen(e)}
                      />
                    </div>
                  ) : (
                    <div style={{ alignSelf: "center", margin: "10px 0 0" }}>
                      <Link
                        href={"/profile"}
                        color="inherit"
                        style={{
                          margin: "5px 5px 0 0",
                          float: "left"
                        }}
                      >
                        <Person />
                        {/* {user.user.name} */}
                      </Link>
                      <Button
                        variant="contained"
                        className={classes.Singout}
                        color="primary"
                        disabled={loading}
                        onClick={() => {
                          setLoading(true);
                          logOut();
                          setLoading(false);
                        }}
                      >
                        {multiLang["017"][lang]}
                      </Button>
                    </div>
                  )}
                </div>
              </div>
              {/* <div
                className={classes.shop}
                onClick={() => window.location.replace("/cart")}
              >
                <Badge
                  count={productnumber}
                  // count={0}
                >
                  {Cart}
                </Badge>
              </div> */}
            </div>
          </Grid>
        </GridContainer>
      </Hidden>
      <Menu
        setUser={setUser}
        setLang={setLang}
        multiLang={multiLang}
        myInvoice={myInvoice}
        isLogin={user.isLogin}
        count={productnumber}
        dir={dir}
        lang={lang}
        // language={language}
        logOut={logOut}
        color="dark"
        brand={
          <Link href={"/home"}>
            <img style={{ width: "100px" }} src={logo} alt={user.user.name} />
          </Link>
        }
        rightLinks={<HeaderLinks categories={categories} lang={lang} />}
        // changeColorOnScroll={{
        //   height: 125,
        //   color: "white"
        // }}
      />
    </div>
  );
};
const mapStateToProps = state => {
  return {
    user: state.user,
    productnumber: state.invoice.productnumber
  };
};
const mapDispatchToProps = dispatch => ({
  setLang: data => dispatch(setLang(data)),
  setUser: user => dispatch(setUser(user)),
  logOut: () => dispatch(logOut()),
  myInvoice: data => dispatch(myInvoice(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
